$(function () {

    $(".submitBtn11").on('click', function () {
        formArray = $('#submitForm1').serialize();
        submitFormData(formArray);
    });

    $(".submitBtn21").on('click', function () {
        formArray = $('#submitForm2').serialize();
        submitFormData(formArray);

    });

    $(".submitBtn31").on('click', function () {
        formArray = $('#submitForm3').serialize();
        submitFormData(formArray);
    });

    $(".submitBtn41").on('click', function () {
        formArray = $('#submitForm4').serialize();
        submitFormData(formArray);
    });

    $(".submitBtn51").on('click', function () {
        formArray = $('#submitForm5').serialize();
        submitFormData(formArray);

    });

    $(".submitBtn12").on('click', function () {
        formArray = $('#submitForm1').serialize();
        draftFormData(formArray);
    });

    $(".submitBtn22").on('click', function () {
        formArray = $('#submitForm2').serialize();
        draftFormData(formArray);

    });

    $(".submitBtn32").on('click', function () {
        formArray = $('#submitForm3').serialize();
        draftFormData(formArray);
    });

    $(".submitBtn42").on('click', function () {
        formArray = $('#submitForm4').serialize();
        draftFormData(formArray);
    });

    $(".submitBtn52").on('click', function () {
        formArray = $('#submitForm5').serialize();
        draftFormData(formArray);

    });

    function submitFormData(formArray) {

        var postURL = "/sales_details/question/save";

        $.ajax({
            url: postURL,
            method: "POST",
            data: formArray,
            type: 'json',
            success: function (data) {
                console.log(data);
                if (data.error) {
                    printErrorMsg(data.error);
                } else {
                    var url = '/sales_details/' + data + '';
                    window.location.href = url
                }
            }
        });
    }

    function draftFormData(formArray) {

        var postURL = "/sales_details/question/draft";

        $.ajax({
            url: postURL,
            method: "POST",
            data: formArray,
            type: 'json',
            success: function (data) {
                console.log(data);
                if (data.error) {
                    printErrorMsg(data.error);
                } else {
                    var url = '/sales_details/' + data + '';
                    window.location.href = url
                }
            }
        });
    }
});